import { Statuses } from "../models/statuses";
import BaseService from "./_base.service";

const endpoint = "statuses";

const StatusesService = {
  ...BaseService<Statuses>({ endpoint })
};

export default StatusesService;
